import { render, staticRenderFns } from "./AgentTable.vue?vue&type=template&id=fbae73f8&"
import script from "./AgentTable.vue?vue&type=script&lang=ts&"
export * from "./AgentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports